import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { reduxForm, Field, change } from 'redux-form';
import InputField from './InputField';
import CheckboxField from './CheckboxField';
import FormError from './FormError';
import { hasComma, isNotEmail } from '../helpers/validators';
import { formatSaveStatus } from '../helpers/formatters';
import SelectField from './SelectField';

class NewChildUserForm extends Component {
  componentDidUpdate (prevProps) {
    if (!this.props.isPhone && this.props.isPhone !== prevProps.isPhone) {
      this.props.dispatch(change('newChildUser', 'phone_number', ''));
    }
  }

  render () {
    const {
      handleSubmit,
      saveStatus,
      error,
      isPhone,
      aclGroups,
      parentId,
      user,
    } = this.props;
    if (saveStatus === 'SUCCEEDED') {
      return <Redirect to={`/users/`} />;
    }
    if (!user) {
      return (
        <div>Loading...</div>
      );
    }
    const { first_name, last_name } = user;
    const parentOptions = [[parentId, `${first_name} ${last_name}`]];
    return (
      <div>
        <h1>New Child User</h1>
        <form onSubmit={handleSubmit}>
          <Field component={SelectField} name='parent' disabled={true} options={parentOptions} label='Parent*' />
          <Field component={InputField} name='email' label='Email*' />
          <Field component={InputField} name='first_name' label='First Name*' />
          <Field component={InputField} name='last_name' label='Last Name*' />
          <Field
            component={SelectField}
            name='acl_group_name'
            label='Acl Group Name*'
            empty='Select user group'
            options={aclGroups}
            onChange={this.onSelectChange}
          />
          <div style={{ display: isPhone ? 'none' : 'block' }}>
            <Field component={InputField} name='phone_number' label='Phone Number' />
          </div>
          <Field component={CheckboxField} name='no_phone' type='checkbox' />
          {error &&
            <FormError error={error} />
          }
          <br />
          <button className='btn btn-default' disabled={saveStatus === 'PENDING'}>
            Create Child User
          </button>
          <span className='submit-status'>
            {formatSaveStatus(saveStatus)}
          </span>
        </form>
      </div>
    );
  }
}

const validate = (values, { isReseller }) => {
  let errors = {};
  if (!values.email) {
    errors.email = 'Required';
  } else if (isNotEmail(values.email)) {
    errors.email = 'Invalid email';
  }
  if (!values.first_name) {
    errors.first_name = 'Required';
  } else if (hasComma(values.first_name)) {
    errors.first_name = 'Comma sign is not allowed';
  }

  if (!values.last_name) {
    errors.last_name = 'Required';
  } else if (hasComma(values.last_name)) {
    errors.last_name = 'Comma sign is not allowed';
  }

  if (!values.acl_group_name) {
    errors.acl_group_name = 'Required';
  }
  if (!values.parent) {
    errors.parent = 'Required';
  }

  return errors;
};

NewChildUserForm = reduxForm({
  form: 'newChildUser',
  validate,
  enableReinitialize: true,
})(NewChildUserForm);

export default NewChildUserForm;

